(() => {
  let comboBusy = false;

  function isComboPage() {
    return Boolean(document.querySelector('.essential-upsell-product-addon-block'));
  }

  function getComboProductForm(target) {
    if (!(target instanceof Element)) return null;
    const button = target.closest('product-form [type="submit"]');
    if (!button || button.name !== 'add') return null;
    const productForm = button.closest('product-form');
    const form = productForm?.querySelector('form');
    if (!productForm || !form) return null;
    return { productForm, form, button };
  }

  function showComboError(productForm, message) {
    const wrapper = productForm.querySelector('.product-form__error-message-wrapper');
    const error = wrapper?.querySelector('.product-form__error-message');
    if (!wrapper || !error) return;
    wrapper.toggleAttribute('hidden', !message);
    if (message) error.textContent = message;
  }

  async function forceComboAdd(productForm, form, button) {
    if (comboBusy || button.getAttribute('aria-disabled') === 'true') return;
    comboBusy = true;

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const spinner = productForm.querySelector('.loading-overlay__spinner');

    try {
      showComboError(productForm, false);
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      spinner?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
      }
      config.body = formData;

      const response = await fetch(routes.cart_add_url, config);
      const data = await response.json();

      if (data.status) {
        showComboError(productForm, data.description || 'Unable to add this item to your cart.');
        return;
      }

      if (cart && typeof cart.renderContents === 'function') {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(data);
        if (typeof cart.open === 'function') {
          setTimeout(() => cart.open(), 0);
        }
      } else {
        console.error('Fahrya combo cart fix: cart drawer component was not found.');
      }
    } catch (error) {
      console.error('Fahrya combo cart fix:', error);
      showComboError(productForm, 'Unable to add this item to your cart. Please try again.');
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
      comboBusy = false;
    }
  }

  document.addEventListener('click', (event) => {
    if (!isComboPage()) return;
    const match = getComboProductForm(event.target);
    if (!match) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    forceComboAdd(match.productForm, match.form, match.button);
  }, true);

  document.addEventListener('submit', (event) => {
    if (!isComboPage()) return;
    if (!(event.target instanceof HTMLFormElement)) return;
    const productForm = event.target.closest('product-form');
    if (!productForm) return;
    const button = productForm.querySelector('[type="submit"][name="add"]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    forceComboAdd(productForm, event.target, button);
  }, true);
})();

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
